import AbstractPageBaseController from '../../../../../modules/core/abstracts/controllers/page-controller';

export default class AbstractGuestlistDetailsPageController extends AbstractPageBaseController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.api = this.injector.get('$http');
        this.navHelper = this.injector.get('NavHelper');
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
        this.acl = this.injector.get('Acl');
        this.alert = this.injector.get('Alert');
        this.userStore = this.injector.get('Users');

        this.loading = true;
        this.currentGuestlistId = null;
        this._updateNav();
    }

    $onInit() {
        if (this.stateParams.guestlist) {
            this.guestlist = this.stateParams.guestlist;
            this.currentGuestlistId = _.clone(this.guestlist.id);
            this._handleGuestlistSelect();
        } else {
            this.currentGuestlistId = _.clone(this.stateParams.gid);
            this._loadGuestlist();
        }
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.stateParams.gid,
            (newVal) => {
                if (!_.isEqual(newVal, this.currentGuestlistId)) {
                    this.stateParams.guestlist = null;
                    this._loadGuestlist();
                }
            }
        )
    }

    reloadGuestlist() {
        console.log('reloading guestlist');
        this._loadGuestlist();
    }

    _loadGuestlist() {
        this.loading = true;

        return this.api.get(`guestlists/${this.stateParams.gid}?include=blockedSeatplanElements,seatplan`)
            .then(({data}) => {
                this.guestlist = data.data;
                this.stateParams.guestlist = _.cloneDeep(this.guestlist);
                this._handleGuestlistSelect();

                return this.guestlist;
            })
    }

    _handleGuestlistSelect() {
        this.loading = false;
        this._updateNav();
    }

    _updateNav() {
        this.navHelper.triggerUpdate();
        this.navHelper.setTranslationsParamsForEntry('events.guestlists.details.main', {
            name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.guestlist.name
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/abstract-details-controller.js